import { observer } from 'mobx-react-lite';
import React from 'react';
import { BrowserRouter, Redirect, Route, Switch } from 'react-router-dom';
import { CurrentUserProvider } from '@uplift/providers';
import { ROUTING_CONFIG } from '@uplift/constants';
import { useStore } from '@uplift/hooks';
import { AlertProvider, MainLayoutProvider, UpliftThemeProvider } from '@uplift/ui-v2';


import { Page404 } from '@uplift/pages';
import { UpliftBetterHelpIcon } from '@uplift/icons';
import { Box, Container } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import { LoginPage } from '../pages/login-page';
import { ResetPasswordPage } from '../pages/reset-password-page';
import { SetPasswordPage } from '../pages/set-password-page';
import Bg from '../assets/images/bg.png';

const useStyles = makeStyles()(theme => ({
  container: {
    paddingBottom: '50px',
    paddingTop: '50px',
    minHeight: '100vh',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: '#E5E5E5',
    flexDirection: 'column',
    maxWidth: '100%',
    backgroundImage: `url(${Bg})`,
    flexGrow: 1,
  },
  box: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',

    maxWidth: '792px',
    width: '100%',
    background: '#FFFFFF',
    boxShadow: theme.shadows[2],
    borderRadius: '4px',
    position: 'relative',
    minHeight: '656px',
    padding: theme.spacing(4, 3),
    [theme.breakpoints.up('sm')]: {
      padding: theme.spacing(4, 10),
    },
  },
  logo: {
    marginBottom: '20px',
  },
}));

const AppRoot: React.FC = () => {
  const { classes } = useStyles();

  return (
    <MainLayoutProvider>
      <Container className={classes.container}>
        <Box className={classes.logo}>
          <UpliftBetterHelpIcon />
        </Box>
        <Box className={classes.box}>
          <Switch>
            <Route exact path={ROUTING_CONFIG.login}>
              <LoginPage />
            </Route>
            <Route exact path={ROUTING_CONFIG.resetPassword}>
              <ResetPasswordPage />
            </Route>
            <Route path={ROUTING_CONFIG.setPassword}>
              <SetPasswordPage />
            </Route>
            <Route path="/404" component={Page404} />
            <Route
              path={ROUTING_CONFIG.any}
              render={() => <Redirect to={ROUTING_CONFIG.login} />}
            />
            <Route component={Page404} />
          </Switch>
        </Box>
      </Container>
    </MainLayoutProvider>
  );
};

export const App = observer(() => {
  const { authStore } = useStore();

  return (
    <CurrentUserProvider isLoggedIn={authStore.isLoggedIn} accessToken={authStore?.tokens?.accessToken}>
      <UpliftThemeProvider>
        <AlertProvider>
          <BrowserRouter>
            <AppRoot />
          </BrowserRouter>
        </AlertProvider>
      </UpliftThemeProvider>
    </CurrentUserProvider>
  );
});
